export enum ResultConversionCode {
    NONE = 'NONE',
    DV = 'DV',
    LC = 'LC'
}
